// PayPalMark — the PayPal "PP" monogram as an inline SVG, for the donate
// button (DonationDriveCard's CTA). Path taken from the simple-icons
// project (CC0). Drawn with fill="currentColor" so it inherits the button's
// text color and stays legible on every theme, with zero network requests.
interface PayPalMarkProps {
  /** Rendered square size in px. Default 15 ≈ x-height next to 13px text. */
  size?: number;
}
export function PayPalMark({ size = 15 }: PayPalMarkProps) {
  return (
    <svg class="paypal-mark" width={size} height={size} viewBox="0 0 24 24"
      // Decorative: the button's own text already says "PayPal", so keep the mark out of the accessibility tree to avoid double-announcing it.
      aria-hidden="true" fill="currentColor">
      <path d="M7.016 19.198h-4.2a.562.562 0 0 1-.555-.65L5.093.584A.692.692 0 0 1 5.776 0h7.222c3.417 0 5.904 2.488 5.846 5.5-.006.25-.027.5-.066.747A6.794 6.794 0 0 1 12.071 12H8.743a.69.69 0 0 0-.682.583l-.325 2.056-.013.083-.692 4.39-.015.087zM19.79 6.142c-.01.087-.01.175-.023.261a7.76 7.76 0 0 1-7.695 6.598H9.007l-.283 1.795-.013.083-.692 4.39-.134.843-.014.088H6.86l-.497 3.15a.562.562 0 0 0 .555.65h3.612c.34 0 .63-.249.683-.585l.952-6.031a.692.692 0 0 1 .683-.584h2.126a6.793 6.793 0 0 0 6.707-5.752c.306-1.95-.466-3.744-1.89-4.906z" />
    </svg>
  );
}
